<template>
  <span class="n-icon">
    <svg :fill="fill" viewBox="0 0 24 24">
      <path fill="currentColor" d="M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z" />
    </svg>
  </span>
</template>

<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-skip-previous-icon',
});
</script>
